// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page-title-module--wrapper--1hi83","innerWrapper":"page-title-module--innerWrapper--_3Vo6"};